import textMorph from '../utils/_text-morph'

export default function TextMorph() {

  const MORPH_TEXT = document.querySelector('.text-morph');

  if (MORPH_TEXT) {
    const DATA_WORDS = document.querySelector('[data-words]').getAttribute('data-words');
    const WORDS = DATA_WORDS.split(',');
    const INTERVAL = 3000;
    let counter = 1;

    MORPH_TEXT.classList.add('show');
    setInterval(function () {
      const FIRST_WORD = MORPH_TEXT.textContent;
      const SECOND_WORD = WORDS[counter];

      textMorph(MORPH_TEXT, FIRST_WORD, SECOND_WORD);

      if (counter < WORDS.length - 1) {
        counter++;
      } else {
        counter = 0;
      }
    }, INTERVAL);
  }

}